// extracted by mini-css-extract-plugin
module.exports = {"container":"_343b1c8e","faqbox":"_7f83f56e","title":"e6934d0a"};